import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppLayout } from './layout/app.layout';

@Component({
	selector: 'wo-admin-shell',
	imports: [AppLayout],
	templateUrl: './admin-shell.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminShellComponent {}
